import { PaginationState } from "@tanstack/react-table";

export type PaymentInstallmentStatusFilter =
  | ""
  | "paid"
  | "pending"
  | "overdue"
  | "inArrears";

export interface PaymentInstallmentRow {
  id: string;
  operationId?: string;
  clientId: string;
  paidAt?: string | null;
  date: string;
  amountUsd: number;
  clientName: string;
  status: string;
  statusName: string;
}

export interface PaymentInstallmentIndicators {
  total: number;
  paid: number;
  pending: number;
  overdue: number;
  inArrears: number;
}

export interface PaymentInstallmentListParams {
  page?: number;
  limit?: number;
  globalFilter?: string;
  startDate?: string;
  endDate?: string;
  status?: PaymentInstallmentStatusFilter;
}

export interface PaymentInstallmentListResult {
  data: PaymentInstallmentRow[];
  totalCount: number;
}

export type PaymentInstallmentPagination = PaginationState;

export const getEmptyPaymentInstallmentIndicators =
  (): PaymentInstallmentIndicators => ({
    total: 0,
    paid: 0,
    pending: 0,
    overdue: 0,
    inArrears: 0,
  });
